import { RadioGroup, Flex, Grid, Text } from "@radix-ui/themes";
import { useRef, useEffect, useState } from "react";
import { useSurveyStore } from "@src/store/survey";
import PropTypes from "prop-types";
import { useMutation } from "@tanstack/react-query";
import { recordResponse } from "@src/api/survey";

RespondentType.propTypes = {
  question: PropTypes.object,
};

export default function RespondentType({ question }) {
  const sessionUUID = useSurveyStore((state) => state.sessionUUID);
  const surveyResponses = useSurveyStore((state) => state.surveyResponses);
  const setSurveyResponses = useSurveyStore(
    (state) => state.setSurveyResponses,
  );
  const [selected, setSelected] = useState();
  const uuid = useRef(null);
  const response = useMutation({
    mutationFn: recordResponse,
    onSuccess: (data) => {
      setSurveyResponses((state) => {
        return { ...state.surveyResponses, [question.uuid]: data };
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  useEffect(() => {
    uuid.current = self.crypto.randomUUID();
  }, []);

  useEffect(() => {
    let value = surveyResponses?.[question?.uuid]?.response.selected;
    if (value) setSelected(value.id);
  }, [surveyResponses, question]);

  async function valueChange(value) {
    if (value === undefined) {
      return;
    }
    setSelected(value);

    const questionOption = question?.options.options.find(
      (option) => option.id == value,
    );

    let responseData = {
      selected: questionOption,
    };

    response.mutate({
      answerUUID: uuid.current,
      response: responseData,
      sessionUUID: sessionUUID,
      surveyQuestionUUID: question.uuid,
    });
  }

  if (question !== undefined) {
    return (
      <RadioGroup.Root value={selected} onValueChange={valueChange}>
        <Flex direction="column" width="100%">
          <Text as="p" size="3" mb="2" weight="bold">
            {question.question}
          </Text>
          <Text as="p" size="1" color="gray" mb="2">
            {question.hint_text}
          </Text>
        </Flex>
        <Grid columns="2" rows="repeat(2)" width="auto">
          {question.options.options.map((option, idx) => (
            <RadioGroup.Item value={option.id} key={idx}>
              {option.label}
            </RadioGroup.Item>
          ))}
        </Grid>
      </RadioGroup.Root>
    );
  } else {
    return null;
  }
}
